import React from "react";

interface PaginationAndSearchProps {
  page: number;
  size: number;
  handlePaginationNext: () => void;
  handlePaginationPrev: () => void;
  search?: string;
  setSearch?: React.Dispatch<React.SetStateAction<string>>;
  showSearch?: boolean;
  placeholder?: string
}

const PaginationSearch: React.FC<PaginationAndSearchProps> = ({
  page,
  size,
  handlePaginationNext,
  handlePaginationPrev,
  search,
  setSearch,
  showSearch = true,
  placeholder = "Search By User ID"
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between px-4 pb-4 w-full border-b-2 border-gray-300 mb-4 gap-4">
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <span className="font-medium">
          Showing Page {page} Out of {size}
        </span>
        <button
          onClick={handlePaginationPrev}
          className="text-gray-600 hover:text-black disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={page === 1}
        >
          &lt; Previous
        </button>
        <button
          onClick={handlePaginationNext}
          className="text-gray-600 hover:text-black disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={page === size}
        >
          Next &gt;
        </button>
      </div>
      {showSearch && <div className="flex items-center border border-gray-300 rounded-md px-3 py-1.5 w-full sm:w-auto">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 text-gray-400 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21 21l-4.35-4.35M17 10.5A6.5 6.5 0 104 10.5a6.5 6.5 0 0013 0z"
          />
        </svg>
        <input
          value={search}
          onChange={(e) => setSearch && setSearch(e.target.value)}
          type="text"
          placeholder={placeholder}
          className="outline-none text-sm text-gray-600 placeholder-gray-400 bg-transparent w-full"
        />
      </div>}
    </div>
  );
};

export default PaginationSearch;
